import { IMPACTS, IMAGES } from "./data";
import { Reveal, Overline } from "./primitives";

export const Innovation = () => {
  return (
    <section
      id="innovation"
      data-testid="innovation-section"
      className="relative overflow-hidden bg-[#0e3f70] py-24 text-white sm:py-32"
    >
      <div className="absolute inset-0 pm-grid-blue opacity-50" />
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage: `url(${IMAGES.fieldRoad})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
          <div>
            <Reveal>
              <Overline dark>Innovation &amp; Impact</Overline>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-heading text-4xl font-bold leading-[1.06] tracking-tight sm:text-5xl">
                Transforming Agricultural Pipeline Planning
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-7 text-lg leading-relaxed text-white/75">
                PipeMitra transforms pipeline planning from an experience-based
                process into a structured, technology-assisted engineering
                workflow.
              </p>
            </Reveal>
          </div>

          <div className="grid gap-5 sm:grid-cols-2">
            {IMPACTS.map((m, i) => (
              <Reveal key={m.title} delay={i * 0.08}>
                <div className="group h-full rounded-3xl border border-white/12 bg-white/[0.06] p-6 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1.5 hover:border-[#a6d47a]/40 hover:bg-white/[0.1]">
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#5aa72f]/20 text-[#a6d47a]">
                    <m.icon className="h-6 w-6" strokeWidth={1.7} />
                  </div>
                  <h3 className="mt-5 font-heading text-lg font-bold leading-snug tracking-tight">
                    {m.title}
                  </h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-white/70">
                    {m.desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
